import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=3138685f&scoped=true&"
import script from "./PreLoader.vue?vue&type=script&lang=js&"
export * from "./PreLoader.vue?vue&type=script&lang=js&"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=3138685f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3138685f",
  null
  
)

export default component.exports